var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import useTheme from "../../hooks/useTheme";
import React from 'react';
var RatingStar = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colors = useTheme().colors;
    return (React.createElement("svg", __assign({ height: "27", viewBox: "0 0 28 27", width: "28", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fill: color || colors.ratingStar, fillRule: "evenodd", d: "m28 10.3485577c0 .3028846-.21875.5889423-.4375.8076923l-6.1081731 5.9567308 1.4471154 8.4134615c.0168269.1177885.0168269.21875.0168269.3365385 0 .4375-.201923.8413461-.6899038.8413461-.2355769 0-.4711539-.0841346-.6730769-.2019231l-7.5552885-3.9711538-7.55528846 3.9711538c-.21875.1177885-.4375.2019231-.67307692.2019231-.48798077 0-.70673077-.4038461-.70673077-.8413461 0-.1177885.01682692-.21875.03365384-.3365385l1.44711539-8.4134615-6.125-5.9567308c-.20192308-.21875-.42067308-.5048077-.42067308-.8076923 0-.5048077.52163462-.70673078.94230769-.77403847l8.44711539-1.22836538 3.78605772-7.65625c.1514423-.31971154.4375-.68990385.8245192-.68990385s.6730769.37019231.8245192.68990385l3.7860577 7.65625 8.4471154 1.22836538c.4038462.06730769.9423077.26923077.9423077.77403847z" })));
};
export default RatingStar;
//# sourceMappingURL=RatingStar.js.map